var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tm-plan-card" }, [
    _c("div", { staticClass: "tm-plan-card__content" }, [
      _c("h3", { staticClass: "tm-plan-card__title" }, [
        _vm._v(_vm._s(_vm.title))
      ]),
      _c("div", { staticClass: "tm-plan-card__price" }, [
        _c("div", { staticClass: "tm-plan-card__price__price" }, [
          _vm._v(_vm._s(_vm.price) + " ")
        ]),
        _c("div", { staticClass: "tm-plan-card__price__rate" }, [
          _vm._v("per month")
        ])
      ]),
      _c("p", { staticClass: "tm-plan-card__p" }, [
        _vm._v(_vm._s(_vm.description))
      ]),
      _c(
        "ul",
        { staticClass: "tm-plan-card__list" },
        _vm._l(_vm.points, function(point) {
          return _c("li", { staticClass: "tm-plan-card__list__item" }, [
            _c(
              "i",
              {
                staticClass:
                  "tm-plan-card__list__item__icon material-icons-round",
                attrs: { "aria-hidden": "true" }
              },
              [_vm._v("done")]
            ),
            _c("span", { staticClass: "tm-plan-card__list__item__title" }, [
              _vm._v(_vm._s(point))
            ])
          ])
        }),
        0
      )
    ]),
    _c("button", { staticClass: "tm-plan-card__btn" }, [_vm._v("Get started")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }